import { render } from "./NotFound.vue?vue&type=template&id=4e278e46"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=4e278e46&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__